const QA_SESSION_TOKEN_KEY = 'qa_session_token'

export function getOrCreateSessionToken(): string {
  const stored = localStorage.getItem(QA_SESSION_TOKEN_KEY)
  if (stored) return stored
  const token = crypto.randomUUID().replace(/-/g, '')
  localStorage.setItem(QA_SESSION_TOKEN_KEY, token)
  return token
}
